module.exports = __webpack_public_path__ + "img/icon_VisitGeorgia.ab638816.png";